module.exports = __webpack_public_path__ + "img/jetrodder_stopped.effe906b.svg";